import { Link } from 'react-router-dom';
import { hotVideos } from '@/mocks/home';

export default function HotVideos() {
  return (
    <section className="py-12 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-2">
            <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
            <h2 className="text-lg font-heading font-semibold text-foreground-900">热门推荐</h2>
            <span className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
              <i className="ri-fire-line"></i> HOT
            </span>
          </div>
          <Link to="/category" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {hotVideos.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                  {video.duration}
                </div>
                <div className="absolute top-2 left-2 flex items-center gap-1.5">
                  {video.isNew && (
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">新</span>
                  )}
                  {video.isHot && (
                    <span className="px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">热</span>
                  )}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500">
                    <i className="ri-play-fill text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="p-3.5">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {video.rating}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {video.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}